import React from 'react'
import { Checkbox } from 'components/forms'
import { Label } from './styled'
import { StyledInnerElement, PositionedColorTag, RightSideContainer, ToggleOpenButton } from 'components/Tree/nodes/common'

const Region = ({ children, label, status, toggleActive, isOpened, toggleOpened, isSelected, isCheckable, leafCount, activeLeafCount, handleSelect, showLeafCount, checkOnSelect }) => (
	<li>
		<StyledInnerElement isSelectable={checkOnSelect} onClick={handleSelect}>
			{checkOnSelect && <PositionedColorTag color={isSelected ? '#3c4e5a' : null}/>}
			{isCheckable ? <Checkbox
				noForm
				stopPropagation={true}
				onChange={toggleActive}
				checked={status === 'ACTIVE'}
				indeterminate={status === 'PARTIAL_ACTIVE'}
				field='active'
				label={label}
				inline
			/> : <Label fontSize='18px' uppercase>{label}</Label>}
			<RightSideContainer>
				{showLeafCount && <h5>{`${activeLeafCount}/${leafCount}`}</h5>}
				<ToggleOpenButton isOpened={isOpened} toggleOpened={toggleOpened}/>
			</RightSideContainer>
		</StyledInnerElement>
		{isOpened && <ul>
			{children}
		</ul>}
	</li>
)

export default Region
